var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup500(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.244,
    height: 20,
    viewBox: "0 0 19.244 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_500",
    "data-name": "Group 500",
    transform: "translate(807.985 -183.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3794",
    "data-name": "Path 3794",
    d: "M-798.346,203.123c-1.836,0-3.672,0-5.508,0a2.793,2.793,0,0,1-2.773-2.152c-.139-.607-.189-1.234-.273-1.853q-.246-1.816-.484-3.634c-.159-1.2-.323-2.394-.474-3.593a8.253,8.253,0,0,1-.124-1.47,2.62,2.62,0,0,1,1.675-2.388,3.757,3.757,0,0,0,1.734-1.491,6.984,6.984,0,0,1,5.282-3.358,7.1,7.1,0,0,1,7.126,3.362,3.747,3.747,0,0,0,1.74,1.483,2.8,2.8,0,0,1,1.654,2.982c-.178,1.23-.321,2.464-.482,3.7s-.322,2.45-.483,3.676c-.1.771-.194,1.543-.306,2.312a2.8,2.8,0,0,1-2.8,2.425C-794.674,203.129-796.51,203.123-798.346,203.123Zm5-12.675a5.026,5.026,0,0,0-4.88-5.018,5,5,0,0,0-5.144,4.978,5.014,5.014,0,0,0,4.916,5.04A5.014,5.014,0,0,0-793.35,190.448Z",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3795",
    "data-name": "Path 3795",
    d: "M-647.365,289.853a1.255,1.255,0,0,1-.97-.511q-1.02-1.382-2.017-2.781a.808.808,0,0,1,.108-1.03.8.8,0,0,1,1.033-.074c.87.621,1.727,1.26,2.6,1.874a1.421,1.421,0,0,1,.657.986A1.364,1.364,0,0,1-647.365,289.853Z",
    transform: "translate(-150.923 -97.914)",
    fill: "#febaba"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup500);
export default __webpack_public_path__ + "static/media/Group 500.d859b23409b1b5c236381be1dada4863.svg";
export { ForwardRef as ReactComponent };